import type {z} from "zod";
import {AddOfferTemplateNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addOfferTemplateNoteTitleSchema = requiredStringSchema(
  AddOfferTemplateNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addOfferTemplateNoteContentSchema = requiredStringSchema(
  AddOfferTemplateNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const addOfferTemplateNoteFormSchema = AddOfferTemplateNoteBody.strict().extend({
  title: addOfferTemplateNoteTitleSchema,
  content: addOfferTemplateNoteContentSchema,
});
export type AddOfferTemplateNoteFormPayload = z.output<typeof addOfferTemplateNoteFormSchema>;
export const draftAddOfferTemplateNoteFormSchema = addOfferTemplateNoteFormSchema.partial();
export type DraftAddOfferTemplateNoteFormPayload = z.output<
  typeof draftAddOfferTemplateNoteFormSchema
>;
